import { StaffInvitationsScreen } from "@/features/staff";

export default function InvitationsPage() {
  return <StaffInvitationsScreen />;
}
